import React, { useRef, useEffect, useState } from "react";
import ChartCard from "./chartCard";
import SliderOptions from "../sliderOptions";
import { createPortal } from "react-dom";
import {
  UsersRound,
  UserRoundCheck,
  BriefcaseBusiness,
  UserRoundPlus,
  Database,
  Info,
  ChartLine,
  Calendar,
  Download,
} from "lucide-react";
import { generateRequestId } from "../../../common/common";
import { adminDashboardApi } from "../../../supports/adminDashboardApi";
import Loader from "../../../common/loader";
import DateRangePicker from "../../recruiterProfiler/jobs/floatingLabelDateInput";
import unifiedAuthManager from "../../../services/unifiedAuthManager";
import EmptyState from "../../common/EmptyState";
import XLSX from "xlsx-js-style";
import { useToast } from "../../../common/toastSystem";
const AdminDashboardContent = ({ onActionSelect }) => {
  const [tab, setTab] = useState("Recruiter Analytics");
  const [timeRange, setTimeRange] = useState("Month");
  const [topCards, setTopCards] = useState([]);
  const [isTotalCandidatesApiLoading, setIsTotalCandidatesApiLoading] =
    useState(true);
  const [isActiveRecruitersApiLoading, setIsActiveRecruitersApiLoading] =
    useState(true);
  const [isCandidatesContactedApiLoading, setIsCandidatesContactedApiLoading] =
    useState(true);
  const [totalCandidatesCard, setTotalCandidatesCard] = useState(null);
  const [activeRecruitersCard, setActiveRecruitersCard] = useState(null);
  const [totalVacanciesCard, setTotalVacanciesCard] = useState(null);
  const [candidateFunnelData, setCandidateFunnelData] = useState([]);
  const [candidateFunnelApiLoading, setCandidateFunnelApiLoading] =
    useState(true);
  const [recruiterActivityData, setRecruiterActivityData] = useState([]);
  const [recruiterActivityApiLoading, setRecruiterActivityApiLoading] =
    useState(true);
  const [recruiterActivityOffset, setRecruiterActivityOffset] = useState(0);
  const [recruiterActivityHasMore, setRecruiterActivityHasMore] =
    useState(true);
  const [recruiterActivityLoadingMore, setRecruiterActivityLoadingMore] =
    useState(false);

  const [recruiterLeaderboardData, setRecruiterLeaderboardData] = useState([]);
  const [recruiterLeaderboardApiLoading, setRecruiterLeaderboardApiLoading] =
    useState(true);
  const [recruiterLeaderboardOffset, setRecruiterLeaderboardOffset] =
    useState(0);
  const [recruiterLeaderboardHasMore, setRecruiterLeaderboardHasMore] =
    useState(true);
  const [recruiterLeaderboardLoadingMore, setRecruiterLeaderboardLoadingMore] =
    useState(false);
  const [locationChartData, setLocationChartData] = useState([]);
  const [locationChartApi, setLocationChartApi] = useState(true);
  const [ageChartData, setAgeChartData] = useState([]);
  const [ageChartApiLoading, setAgeChartApiLoading] = useState(true);
  const [nationalityChartData, setNationalityChartData] = useState([]);
  const [allNationalityChartData, setAllNationalityChartData] = useState([]);
  const [nationalityChartApiLoading, setNationalityChartApiLoading] =
    useState(true);
  const [genderChartData, setGenderChartData] = useState([]);
  const [genderChartDataApiLoading, setgenderChartDataApiLoading] =
    useState(true);
  const [loading, setLoading] = useState(true);
  const [cvOriginChartData, setCvOriginChartData] = useState([]);
  const [cvOriginChartApiLoading, setCVOriginChartApiLoading] = useState(true);
  const [sectorWiseChartData, setSectorWiseChartData] = useState([]);
  const [sectorWiseChartApiLoading, setSectorWiseChartApiLoading] =
    useState(true);
  const [hitRatioChartData, setHitRatioChartData] = useState([]);
  const [hitRatioChartApiLoading, setHitRatioChartApiLoading] = useState(true);
  const [jobLocationsChartData, setJobLocationsChartData] = useState([]);
  const [jobLocationsChartApiLoading, setJobLocationsChartApiLoading] = useState(true);
  const [sectorwiseCandidatesData, setSectorWiseCandidatesData] = useState([]);
  const [sectorWiseCandidatesApiLoading, setSectorWiseCandidatesApiLoading] = useState(false);
  const [sectorWiseVacanciesData, setSectorWiseVacanciesData] = useState([]);
  const [sectorWiseVacanciesApiLoading, setSectorWiseVacanciesApiLoading] = useState(false);

  const [candidateFunnelDetailData, setCandidateFunnelDetailData] = useState([]);
const [genderChartDetailData, setGenderChartDetailData] = useState([]);
const [nationalityChartDetailData, setNationalityChartDetailData] = useState([]);
const [ageChartDetailData, setAgeChartDetailData] = useState([]);
const [locationChartDetailData, setLocationChartDetailData] = useState([]);
const [cvOriginChartDetailData, setCvOriginChartDetailData] = useState([]);
const [sectorWiseChartDetailData, setSectorWiseChartDetailData] = useState([]);
const [hitRatioChartDetailData, setHitRatioChartDetailData] = useState([]);
const [jobLocationsChartDetailData, setJobLocationsChartDetailData] = useState([]);
const [sectorwiseCandidatesDetailData, setSectorwiseCandidatesDetailData] = useState([]);
const [sectorWiseVacanciesDetailData, setSectorWiseVacanciesDetailData] = useState([]);

  // Date Range State
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef();
  const toast = useToast();
  const user = unifiedAuthManager.getUnifiedUser();
  console.log("User info in admin dashboard content:", user);
  const performanceLoadingSetters = [
    setRecruiterLeaderboardApiLoading,
    setRecruiterActivityApiLoading,
    setCandidateFunnelApiLoading,
  ];

  const demographicsLoadingSetters = [
    setCVOriginChartApiLoading,
    setLocationChartApi,
    setJobLocationsChartApiLoading,
    setAgeChartApiLoading,
    setNationalityChartApiLoading,
    setgenderChartDataApiLoading,
    setSectorWiseChartApiLoading,
    setSectorWiseCandidatesApiLoading,
  ];

  const setLoadingStates = (states, value) => {
    states.forEach((fn) => fn(value));
  };

  const getPeriodDates = (period, date = new Date()) => {
    const d = new Date(date);
    let start, end;

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    switch (period.toLowerCase()) {
      case "month":
        start = new Date(d.getFullYear(), d.getMonth(), 1);
        end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
        break;
      case "quarter": {
        const quarter = Math.floor(d.getMonth() / 3);
        start = new Date(d.getFullYear(), quarter * 3, 1);
        end = new Date(d.getFullYear(), quarter * 3 + 3, 0);
        break;
      }
      case "year":
        start = new Date(d.getFullYear(), 0, 1);
        end = new Date(d.getFullYear(), 11, 31);
        break;
      default:
        throw new Error('Invalid period. Use "month", "quarter", or "year"');
    }

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  useEffect(() => {
    fetchDashboardData();
  }, [tab, timeRange, startDate, endDate]);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      setIsTotalCandidatesApiLoading(true);
      setIsCandidatesContactedApiLoading(true);
      setIsActiveRecruitersApiLoading(true);
      await Promise.allSettled([
        fetchTotalCandidates(),
        fetchTotalVacancies(),
        fetchActiveRecruiters(),
      ]);
      if (tab === "Recruiter Analytics") {
        setLoadingStates(performanceLoadingSetters, true);
        await Promise.allSettled([
          fetchCandidateFunnelChart(),
          recruiterActivityChart(),
          fetchRecruiterLeaderboardChart(),
        ]);
      } else {
        setLoadingStates(demographicsLoadingSetters, true);
        await Promise.allSettled([
          fetchGenderChart(),
          fetchNationalityChart(),
          fetchJobLocationsChart(),
          fetchAgeChart(),
          fetchLocationChart(),
          fetchCvChart(),
          fetchSectorWiseChart(),
          fetchHitRatioChart(),
          fetchSectorWiseCandidates(),
          fetchSectorWiseVacancies()
        ]);
      }
    } catch (error) {
      console.error("Dashboard data fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalCandidates = async () => {
    try {
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchTotalCandidates(payload);
      if (response && response.success) {
        setTotalCandidatesCard(response.data);
      } else {
      }
    } catch (error) {
      console.log("error in fetchTotalCandidates" + error);
    } finally {
      setIsTotalCandidatesApiLoading(false);
    }
  };

  const fetchTotalVacancies = async () => {
    try {
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };

      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchTotalVacancies(payload);
      if (response && response.success) {
        setTotalVacanciesCard(response.data);
      } else {
        setTotalVacanciesCard(null);
      }
    } catch (error) {
      console.log("error in fetchTotalVacancies" + error);
    } finally {
      setIsCandidatesContactedApiLoading(false);
    }
  };

  const fetchActiveRecruiters = async () => {
    try {
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };

      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchActiveRecruiteres(payload);
      if (response && response.success) {
        setActiveRecruitersCard(response.data);
      } else {
        setActiveRecruitersCard(null);
      }
    } catch (error) {
      console.log("error in fetchTotalCandidates" + error);
    } finally {
      setIsActiveRecruitersApiLoading(false);
    }
  };

  const fetchCandidateFunnelChart = async () => {
    try {
      setCandidateFunnelApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchCandidateFunnelChart(payload);
      if (response && response.success) {
        let chartData = [
          {
            name: "Total Candidates",
            value: response.data.total_candidates || 0,
          },

          {
            name: "Viewed",
            value: response.data.viewed_candidates || 0,
          },
          {
            name: "Contacted via Whatsapp",
            value: response.data.contacted_via_whatsapp || 0,
          },
          {
            name: "Contacted via Email",
            value: response.data.contacted_via_email || 0,
          },

          {
            name: "Submitted to AM",
            value: response.data.submitted_to_am || 0,
          },
          {
            name: "Placed",
            value: response.data.total_placed_candidates || 0,
          },
        ];
        setCandidateFunnelData(chartData);
        setCandidateFunnelDetailData(response.data?.details || []);
      } else {
        setCandidateFunnelDetailData([]);
        setCandidateFunnelData([]);
      }
    } catch (error) {
      console.log("error in fetchTotalCandidates" + error);
    } finally {
      setCandidateFunnelApiLoading(false);
    }
  };

    const fetchSectorWiseCandidates = async () => {
    try {
      setSectorWiseCandidatesApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchSectorWiseCandidates(payload);
      console.log(response);
      
      if (response && response.success) {
        let chartData = response.data?.sector_candidates
      if (chartData && Array.isArray(chartData)) {
          const total = chartData.reduce(
            (sum, item) => sum + (item.value || 0),
            0
          );

          const toPercent = (v) =>
            total > 0 ? Number(((v / total) * 100).toFixed(2)) : 0;

          const percentageData = chartData.map((item) => ({
            ...item,
            actual_value: item.value,
            value: toPercent(item.value || 0),
          }));

          setSectorWiseCandidatesData(percentageData);
          setSectorwiseCandidatesDetailData(response.data?.details || []);
        } else {
          setSectorwiseCandidatesDetailData([]);
          setSectorWiseCandidatesData([]);
        }
        
      } else {
        setSectorwiseCandidatesDetailData([])
        setSectorWiseCandidatesData([]);
      }
    } catch (error) {
      console.log("error in fetchSectorWiseCandidates" + error);
    } finally {
      setSectorWiseCandidatesApiLoading(false);
    }
  };

  const fetchSectorWiseVacancies = async () => {
    try {
      setSectorWiseVacanciesApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchSectorWiseVacancies(payload);
      if (response && response.success) {
        let chartData = response.data?.sector_vacancies;
        if (chartData && Array.isArray(chartData)) {
          const total = chartData.reduce(
            (sum, item) => sum + (item.value || 0),
            0
          );
          const toPercent = (v) =>
            total > 0 ? Number(((v / total) * 100).toFixed(2)) : 0;
          const percentageData = chartData.map((item) => ({
            ...item,
            actual_value: item.value,
            value: toPercent(item.value || 0),
          }));
          setSectorWiseVacanciesData(percentageData);
          setSectorWiseVacanciesDetailData(response.data?.details || []);
        } else {
          setSectorWiseVacanciesDetailData([]);
          setSectorWiseVacanciesData([]);
        }
      } else {
        setSectorWiseVacanciesDetailData([]);
        setSectorWiseVacanciesData([]);
      }
    } catch (error) {
      console.log("error in fetchSectorWiseVacancies" + error);
    } finally {
      setSectorWiseVacanciesApiLoading(false);
    }
  };

  const recruiterActivityChart = async (offset = 0) => {
    try {
      if (offset === 0) {
        setRecruiterActivityApiLoading(true);
      } else if (offset > 0) {
        setRecruiterActivityLoadingMore(true);
      }
      let payload = {
        period: timeRange?.toLowerCase(),
        offset: offset,
        limit: offset === null ? null : 10,
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };

      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchRecruiterActivityChart(
        payload
      );
      console.log(response);
      if (response && response.success) {
        if (offset === null) {
          exportToExcel("Recruiter Activity", response.data.recruiters);
        } else {
          if (offset === 0) {
            setRecruiterActivityData(response.data.recruiters);
          } else {
            setRecruiterActivityData((prev) => [
              ...prev,
              ...response.data.recruiters,
            ]);
          }
          setRecruiterActivityOffset(response.data.next_offset || offset + 5);
          setRecruiterActivityHasMore(response.data.has_more);
        }
      } else {
        setRecruiterActivityData([]);
      }
    } catch (error) {
      console.log("error in recruiterActivityChart" + error);
    } finally {
      setRecruiterActivityApiLoading(false);
      setRecruiterActivityLoadingMore(false);
    }
  };

  const fetchRecruiterLeaderboardChart = async (offset = 0) => {
    try {
      if (offset === 0) {
        setRecruiterLeaderboardApiLoading(true);
      } else if (offset > 0) {
        setRecruiterLeaderboardLoadingMore(true);
      }
      let payload = {
        period: timeRange?.toLowerCase(),
        offset: offset,
        limit: offset === null ? null : 10,
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };

      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchRecruiterLeaderboardChart(
        payload
      );
      console.log("recruiter leaderboard data", response);
      if (response && response.success) {
        if (offset === null) {
          exportToExcel("Recruiter Leaderboard", response.data.recruiters);
        } else {
          if (offset === 0) {
            setRecruiterLeaderboardData(response.data.recruiters);
          } else {
            setRecruiterLeaderboardData((prev) => [
              ...prev,
              ...response.data.recruiters,
            ]);
          }
          setRecruiterLeaderboardOffset(
            response.data.next_offset || offset + 5
          );
          setRecruiterLeaderboardHasMore(response.data.has_more);
        }
      } else {
        if (offset === 0) {
          setRecruiterLeaderboardData([]);
        }
      }
    } catch (error) {
      console.log("error in fetchRecruiterLeaderboardChart" + error);
    } finally {
      setRecruiterLeaderboardApiLoading(false);
      setRecruiterLeaderboardLoadingMore(false);
    }
  };

  const fetchGenderChart = async () => {
    try {
      setgenderChartDataApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.genderChart(payload);
      console.log("gender chart data", response);
      if (response && response.success) {
        if (response.data?.gender_distribution) {
          const gd = response.data.gender_distribution;
          const male = gd?.male || 0;
          const female = gd?.female || 0;
          const other = gd?.other || 0;
          const unknown = gd?.unknown || 0;

          const total = male + female + other + unknown;

          const toPercent = (v) =>
            total > 0 ? Number(((v / total) * 100).toFixed(2)) : 0;

          let chartData = [
            { name: "Male", value: toPercent(male), actual_value: male },
            { name: "Female", value: toPercent(female), actual_value: female },
            { name: "Others", value: toPercent(other), actual_value: other },
            {
              name: "Unknown",
              value: toPercent(unknown),
              actual_value: unknown,
            },
          ];
          setGenderChartData(chartData);
          setGenderChartDetailData(response.data?.details || []);
        } else {
          setGenderChartDetailData([]);
          setGenderChartData([]);
        }
      } else {
        setGenderChartData([]);
        setGenderChartDetailData([]);
      }
    } catch (error) {
      console.log("error in fetchGenderChart" + error);
    } finally {
      setgenderChartDataApiLoading(false);
    }
  };

  const fetchNationalityChart = async () => {
    try {
      setNationalityChartApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.nationalityChart(payload);
      console.log("nationality chart data ", response);
      if (response && response.success) {
        let nationalityData = response.data?.top_nationalities;
        if (nationalityData) {
          setNationalityChartData(nationalityData);
          setAllNationalityChartData(response.data?.all_nationalities || nationalityData);
          setNationalityChartDetailData(response.data?.details || []);
        } else {
          setAllNationalityChartData([]);
          setNationalityChartDetailData([]);
          setNationalityChartData([]);
        }
      } else {
        setAllNationalityChartData([]);
        setNationalityChartDetailData([]);
        setNationalityChartData([]);
      }
    } catch (error) {
      console.log("error in fetchNationalityChart" + error);
    } finally {
      setNationalityChartApiLoading(false);
    }
  };

  const fetchJobLocationsChart = async () => {
    try {
      setJobLocationsChartApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.jobLocationsChart(payload);
      console.log("job locations chart data ", response);
      if (response && response.success) {
        let chartData = response.data?.top_locations;
        if (chartData && Array.isArray(chartData)) {
          setJobLocationsChartData(chartData);
          setJobLocationsChartDetailData(response.data?.details || []);
        } else {
          setJobLocationsChartDetailData([]);
          setJobLocationsChartData([]);
        }
      } else {
        setJobLocationsChartDetailData([]);
        setJobLocationsChartData([]);
      }
    } catch (error) {
      console.log("error in fetchJobLocationsChart" + error);
    } finally {
      setJobLocationsChartApiLoading(false);
    }
  };

  const fetchAgeChart = async () => {
    try {
      setAgeChartApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.ageChart(payload);
      console.log("age Chart ", response);
      if (response && response.success) {
        let ageData = response.data?.age_distribution;
        if (ageData) {
          let chartData = [
            { name: "18-25", value: ageData["18_25"] },
            { name: "26-35", value: ageData["26_35"] },
            { name: "36-45", value: ageData["36_45"] },
            { name: "46-60", value: ageData["46_60"] },
            { name: "60+", value: ageData["60_plus"] },
          ];
          setAgeChartData(chartData);
          setAgeChartDetailData(response.data?.details || []);
        } else {
          setAgeChartDetailData([]);
          setAgeChartData([]);
        }
      } else {
        setAgeChartDetailData([]);
        setAgeChartData([]);
      }
    } catch (error) {
      console.log("error in fetchAgeChart" + error);
    } finally {
      setAgeChartApiLoading(false);
    }
  };
  const fetchLocationChart = async () => {
    try {
      setLocationChartApi(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.locationChart(payload);
      console.log("location data ", response);
      if (response && response.success) {
        let locationData = response.data?.top_locations;
        // if name is empty string replace with unknown
        if (locationData) {
          locationData = locationData.map(loc => ({
            ...loc,
            name: loc.name || "Not Mentioned"
          }));
          setLocationChartData(locationData);
          setLocationChartDetailData(response.data?.details || []); 
        } else {
          setLocationChartDetailData([]);
          setLocationChartData([]);
        }
      } else {
        setLocationChartDetailData([]);
        setLocationChartData([]);
      }
    } catch (error) {
      console.log("error in fetchLocationChart" + error);
    } finally {
      setLocationChartApi(false);
    }
  };

  const fetchCvChart = async () => {
    try {
      setCVOriginChartApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchCVOriginsChart(payload);
      console.log("cvorigin chart data", response);
      if (response && response.success) {
        let chartData = response.data?.top_cv_origins;
        if (chartData && Array.isArray(chartData)) {
          const total = chartData.reduce(
            (sum, item) => sum + (item.value || 0),
            0
          );

          const toPercent = (v) =>
            total > 0 ? Number(((v / total) * 100).toFixed(2)) : 0;

          const percentageData = chartData.map((item) => ({
            ...item,
            actual_value: item.value,
            value: toPercent(item.value || 0),
          }));

          setCvOriginChartData(percentageData);
          setCvOriginChartDetailData(response.data?.details || []); 
        } else {
          setCvOriginChartDetailData([]);
          setCvOriginChartData([]);
        }
      } else {
        setCvOriginChartDetailData  ([]); 
        setCvOriginChartData([]);
      }
    } catch (error) {
      console.log("error in fetchCvChart" + error);
    } finally {
      setCVOriginChartApiLoading(false);
    }
  };

  const fetchSectorWiseChart = async () => {
    try {
      setSectorWiseChartApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.fetchSectorWiseChart(payload);
      console.log("sector wise chart data", response);
      if (response && response.success) {
        let chartData = response.data?.sector_placements;
        if (chartData && Array.isArray(chartData)) {
          const total = chartData.reduce(
            (sum, item) => sum + (item.value || 0),
            0
          );

          const toPercent = (v) =>
            total > 0 ? Number(((v / total) * 100).toFixed(2)) : 0;

          const percentageData = chartData.map((item) => ({
            ...item,
            actual_value: item.value,
            value: toPercent(item.value || 0),
          }));

          setSectorWiseChartData(percentageData);
          setSectorWiseChartDetailData(response.data?.details || []);
        } else {
          setSectorWiseChartDetailData([]);
          setSectorWiseChartData([]);
        }
      } else {
        setSectorWiseChartDetailData([]); 
        setSectorWiseChartData([]);
      }
    } catch (error) {
      console.log("error in fetchSectorWiseChart" + error);
    } finally {
      setSectorWiseChartApiLoading(false);
    }
  };

  const fetchHitRatioChart = async () => {
    try {
      setHitRatioChartApiLoading(true);
      let payload = {
        period: timeRange?.toLowerCase(),
        user_payload: {
          request_id: generateRequestId(),
          email: "abc",
          tenant: "ABC",
        },
      };
      if (startDate && endDate) {
        payload.start_date = startDate;
        payload.end_date = endDate;
      } else if (startDate) {
        payload.start_date = startDate;
        payload.end_date = startDate;
      } else {
        let { start, end } = getPeriodDates(timeRange);
        payload.start_date = start;
        payload.end_date = end;
      }
      let response = await adminDashboardApi.hitRateChart(payload);
      console.log("sector wise chart data", response);
      if (response && response.success) {
        let chartData = response.data?.sector_hit_rates;
        if (chartData && Array.isArray(chartData)) {
          setHitRatioChartData(chartData);
          setHitRatioChartDetailData(response.data?.details || []);
        } else {
          setHitRatioChartDetailData([]);
          setHitRatioChartData([]);
        }
      } else {
        setHitRatioChartDetailData([]);
        setHitRatioChartData([]);
      }
    } catch (error) {
      console.log("error in fetchHitRatioChart" + error);
    } finally {
      setHitRatioChartApiLoading(false);
    }
  };

//   const exportToExcel = (title, dataArray = []) => {
//     try {
//       const dataMap = {
//         "Candidate Funnel": candidateFunnelData,
//         "Gender Distribution": genderChartData,
//         "Top Nationalities": nationalityChartData,
//         "Age Distribution": ageChartData,
//         "Top Locations": locationChartData,
//         "CV Origins": cvOriginChartData,
//         "Sector Wise Placements": sectorWiseChartData,
//         "Recruiter Activity": dataArray,
//         "Recruiter Leaderboard": dataArray,
//         "Hit Ratio by Sector": hitRatioChartData,
//         "Sector Wise Candidates": sectorwiseCandidatesData
//       };

//       let data = dataMap[title];

//        // Special handling for Recruiter Leaderboard: reorder and filter fields
//     if (title === "Recruiter Leaderboard") {
//       const requiredFields = [
//         "rank", "recruiter_name", "submitted_to_am", "approved_by_am", 
//         "shortlisted", "submitted_to_client", "selected_for_mob", "placed"
//       ];
      
//       data = dataArray.map(row => {
//         const filteredRow = {};
//         requiredFields.forEach(field => {
//           filteredRow[field] = row[field];
//         });
//         return filteredRow;
//       });
//     }
 
//       if (!data?.length) {
//         toast.warning("No data to export!");
//         return;
//       }

//       const wb = XLSX.utils.book_new();
//       const keys = Object.keys(data[0]);
//       const numCols = keys.length;

//       // 1. Prepare formatted Header Names (CamelCase to Title Case)
//    const headerNames = keys.map((key) => {
//   if (!key) return '';
  
//   return key
//     // Replace underscores and hyphens with spaces first
//     .replace(/[_-]/g, ' ')
//     // Insert space before uppercase letters (camelCase handling)
//     .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
//     // Capitalize first letter of each word
//     .replace(/\b\w/g, (match) => match.toUpperCase())
//     // Clean up multiple spaces
//     .replace(/\s+/g, ' ')
//     .trim();
// });

//       // 2. Create the worksheet starting with the data at A3
//       // We pass null for headers initially so we can manually style them
//       const ws = XLSX.utils.json_to_sheet(data, {
//         origin: "A3",
//         skipHeader: false,
//       });

//       // 3. Add the Main Title at A1
//       XLSX.utils.sheet_add_aoa(ws, [[title.toUpperCase()]], { origin: "A1" });

//       // 4. Manual Header Overwrite (to apply Title Case names)
//       XLSX.utils.sheet_add_aoa(ws, [headerNames], { origin: "A3" });

//       // 5. Define Styles
//       const styles = {
//         title: {
//           font: { bold: true, sz: 16, color: { rgb: "#004645;" } },
//           fill: { fgColor: { rgb: "b0d3d2" } },
//           alignment: { horizontal: "center", vertical: "center" },
//         },
//         header: {
//           font: { bold: true, color: { rgb: "#004645;" } },
//           fill: { fgColor: { rgb: "b0d3d2" } },
//           border: {
//             top: { style: "thin", color: { rgb: "000000" } },
//             bottom: { style: "thin", color: { rgb: "000000" } },
//           },
//           alignment: { horizontal: "center" },
//         },
//         evenRow: {
//           fill: { fgColor: { rgb: "E6F4F1" } }, // Light blue stripe
//           border: { bottom: { style: "thin", color: { rgb: "D9D9D9" } } },
//         },
//         oddRow: {
//           fill: { fgColor: { rgb: "FFFFFF" } },
//           border: { bottom: { style: "thin", color: { rgb: "D9D9D9" } } },
//         },
//       };

//       // 6. Apply Styles to Cells
//       const range = XLSX.utils.decode_range(ws["!ref"]);

//       for (let R = range.s.r; R <= range.e.r; ++R) {
//         for (let C = range.s.c; C <= range.e.c; ++C) {
//           const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
//           if (!ws[cellRef]) continue;

//           // Title Row (A1)
//           if (R === 0) {
//             ws[cellRef].s = styles.title;
//           }
//           // Header Row (A3)
//           else if (R === 2) {
//             ws[cellRef].s = styles.header;
//           }
//           // Data Rows (A4 onwards)
//           else if (R > 2) {
//             ws[cellRef].s = R % 2 === 0 ? styles.evenRow : styles.oddRow;
//           }
//         }
//       }

//       // 7. Merge Title Cells
//       ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];

//       // 8. Auto-size Columns
//       ws["!cols"] = keys.map((key, i) => {
//         const maxDataLength = Math.max(
//           headerNames[i].length,
//           ...data.map((row) => String(row[key] ?? "").length)
//         );
//         return { wch: maxDataLength + 5 };
//       });

//       // 9. Export
//       XLSX.utils.book_append_sheet(wb, ws, "Report");
//       const now = new Date();
//       const date = now.toLocaleDateString("en-CA"); // 'en-CA' outputs YYYY-MM-DD

//       // 2. Get the hh:mmam/pm part
//       const time = now
//         .toLocaleTimeString("en-US", {
//           hour: "2-digit",
//           minute: "2-digit",
//           hour12: true,
//         })
//         .toLowerCase()
//         .replace(/\s+/g, ""); // Removes the space (e.g., "12:24 pm" -> "12:24pm")

//       // 3. Combine with a hyphen
//       const timestamp = `${date}-${time}`;
//       const fileName = `${title.replace(/\s+/g, "_")}_${
//         user.displayName
//       }_${timestamp}.xlsx`;

//       XLSX.writeFile(wb, fileName);
//     } catch (error) {
//       console.error("Export Error:", error);
//       alert("Failed to export styled Excel.");
//     }
//   };

  // Scroll handler for recruiter activity table
  
  const exportToExcel = (title, dataArray = [], isDetail = true) => {
    try {
      const dataMap = {
        "Candidate Funnel": candidateFunnelData,
        "Gender Distribution": genderChartData,
        "Top Nationalities": nationalityChartData,
        "Age Distribution": ageChartData,
        "Top Locations": locationChartData,
        "CV Origins": cvOriginChartData,
        "Sector Wise Placements": sectorWiseChartData,
        "Recruiter Activity": dataArray,
        "Recruiter Leaderboard": dataArray,
        "Hit Ratio by Sector": hitRatioChartData,
        "Jobs by location": jobLocationsChartData,
        "Sector Wise Candidates": sectorwiseCandidatesData,
        "Sector Wise Vacancies": sectorWiseVacanciesData
      };

      // Detail data map — add your detail variables here per title
      const detailDataMap = {
        "Candidate Funnel": candidateFunnelDetailData,
        "Gender Distribution": genderChartDetailData,
        "Top Nationalities": nationalityChartDetailData,
        "Age Distribution": ageChartDetailData,
        "Top Locations": locationChartDetailData,
        "CV Origins": cvOriginChartDetailData,
        "Sector Wise Placements": sectorWiseChartDetailData,


        "Hit Ratio by Sector": hitRatioChartDetailData,
        "Jobs by location": jobLocationsChartDetailData,
        "Sector Wise Candidates": sectorwiseCandidatesDetailData,
        "Sector Wise Vacancies": sectorWiseVacanciesDetailData
      };

      let data = dataMap[title];
      let exportTitle = title;

      // Special handling for Top Nationalities: export the full aggregate, not only chart rows.
      if (title === "Top Nationalities") {
        if (allNationalityChartData?.length) {
          data = allNationalityChartData;
        } else {
          const counts = {};
          nationalityChartDetailData.forEach(row => {
            if (row.nationality) {
              counts[row.nationality] = (counts[row.nationality] || 0) + 1;
            }
          });
          data = Object.entries(counts)
            .map(([name, value]) => ({ name, value }))
            .sort((a, b) => b.value - a.value);
        }
        exportTitle = "All Nationalities";
      }

      // Special handling for Recruiter Activity: pick and rename fields
      if (title === "Recruiter Activity") {
        data = dataArray.map(row => ({
          recruiter_name: row.recruiter_name,
          vacancies: row.jobs_count,
          candidate_views: row.candidate_views,
          contacted_candidates: row.contacted_candidates,
          email_contacted_candidates: row.email_contacted_candidates,
          whatsapp_contacted_candidates: row.whatsapp_contacted_candidates,
        }));
      }

      // Special handling for Recruiter Leaderboard: reorder and filter fields
      if (title === "Recruiter Leaderboard") {
        const requiredFields = [
          "rank", "recruiter_name", "submitted_to_am", "approved_by_am",
          "shortlisted", "submitted_to_client", "selected_for_mob", "placed"
        ];

        data = dataArray.map(row => {
          const filteredRow = {};
          requiredFields.forEach(field => {
            filteredRow[field] = row[field];
          });
          return filteredRow;
        });
      }

      if (!data?.length) {
        toast.warning("No data to export!");
        return;
      }

      const wb = XLSX.utils.book_new();

      // ─── Helper: build a styled worksheet from a data array ───────────────
      const buildSheet = (sheetData, sheetTitle) => {
        const keys = Object.keys(sheetData[0]);
        const numCols = keys.length;

        const headerNames = keys.map((key) => {
          if (!key) return '';
          return key
            .replace(/[_-]/g, ' ')
            .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
            .replace(/\b\w/g, (match) => match.toUpperCase())
            .replace(/\s+/g, ' ')
            .trim();
        });

        const ws = XLSX.utils.json_to_sheet(sheetData, {
          origin: "A3",
          skipHeader: false,
        });

        XLSX.utils.sheet_add_aoa(ws, [[sheetTitle.toUpperCase()]], { origin: "A1" });
        XLSX.utils.sheet_add_aoa(ws, [headerNames], { origin: "A3" });

        const styles = {
          title: {
            font: { bold: true, sz: 16, color: { rgb: "#004645;" } },
            fill: { fgColor: { rgb: "b0d3d2" } },
            alignment: { horizontal: "center", vertical: "center" },
          },
          header: {
            font: { bold: true, color: { rgb: "#004645;" } },
            fill: { fgColor: { rgb: "b0d3d2" } },
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
            },
            alignment: { horizontal: "center" },
          },
          evenRow: {
            fill: { fgColor: { rgb: "E6F4F1" } },
            border: { bottom: { style: "thin", color: { rgb: "D9D9D9" } } },
          },
          oddRow: {
            fill: { fgColor: { rgb: "FFFFFF" } },
            border: { bottom: { style: "thin", color: { rgb: "D9D9D9" } } },
          },
        };

        const range = XLSX.utils.decode_range(ws["!ref"]);

        for (let R = range.s.r; R <= range.e.r; ++R) {
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
            if (!ws[cellRef]) continue;

            if (R === 0) {
              ws[cellRef].s = styles.title;
            } else if (R === 2) {
              ws[cellRef].s = styles.header;
            } else if (R > 2) {
              ws[cellRef].s = R % 2 === 0 ? styles.evenRow : styles.oddRow;
            }
          }
        }

        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];

        ws["!cols"] = keys.map((key, i) => {
          const maxDataLength = Math.max(
            headerNames[i].length,
            ...sheetData.map((row) => String(row[key] ?? "").length)
          );
          return { wch: maxDataLength + 5 };
        });

        return ws;
      };
      // ──────────────────────────────────────────────────────────────────────

      // Main "Report" sheet (always created)
      const mainSheet = buildSheet(data, exportTitle);
      XLSX.utils.book_append_sheet(wb, mainSheet, "Report");

      // "Details" sheet (only when isDetail is true)
      const detailData = detailDataMap[title];
        if (detailData?.length) {
          const detailSheet = buildSheet(detailData, `${exportTitle} - Details`);
          XLSX.utils.book_append_sheet(wb, detailSheet, "Details");
        }
      // Export
      const now = new Date();
      const date = now.toLocaleDateString("en-CA");
      const time = now
        .toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
        .toLowerCase()
        .replace(/\s+/g, "");

      const timestamp = `${date}-${time}`;
      const fileName = `${exportTitle.replace(/\s+/g, "_")}_${user.displayName}_${timestamp}.xlsx`;

      XLSX.writeFile(wb, fileName);
    } catch (error) {
      console.error("Export Error:", error);
      alert("Failed to export styled Excel.");
    }
  };
  
  const handleRecruiterActivityScroll = (e) => {
    const element = e.target;
    const isAtBottom =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (
      isAtBottom &&
      recruiterActivityHasMore &&
      !recruiterActivityLoadingMore
    ) {
      recruiterActivityChart(recruiterActivityOffset);
    }
  };

  const handleExportToExcel = (heading) => {
    exportToExcel(heading);
  };

  // Scroll handler for recruiter leaderboard table
  const handleRecruiterLeaderboardScroll = (e) => {
    const element = e.target;
    const isAtBottom =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (
      isAtBottom &&
      recruiterLeaderboardHasMore &&
      !recruiterLeaderboardLoadingMore
    ) {
      fetchRecruiterLeaderboardChart(recruiterLeaderboardOffset);
    }
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";

    const [y, m, d] = dateStr.split("-");
    const dateObj = new Date(y, m - 1, d);

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = dateObj.toLocaleString("en-US", { month: "short" });
    const year = dateObj.getFullYear();

    return `${day} ${month} ${year}`;
  };

  return (
    <div className="overflow-auto">
      <div className="backdrop-blur-sm px-5 pt-2">
        <div className="mt-4">
          <h1 className="text-base font-bold text-gray-333">
            Executive Dashboard
          </h1>
        </div>
        {/* <h1 className="text-base font-bold py-2">Executive Dashboard</h1>
         <h1 className="text-xs text- font-semibold relative text-orange-500 flex gap-2">
                                <Info size={14}/>
                                The data displayed below is for demonstration purposes only and does not represent real or live data.</h1> */}
        <div className="flex justify-between items-center w-full backdrop-blur-sm py-2">
          <SliderOptions
            origin="adminDashboard"
            options={["Recruiter Analytics", "Candidate Demographics"]}
            defaultValue={tab}
            onChange={(data) => {
              setTab(data);
              // if (data === "Recruiter Analytics") {
              //   setLoadingStates(performanceLoadingSetters, true);
              // } else {
                
              // }
            }}
          />

          <div className="flex items-center gap-2">
            <div
              className={`opacity-${startDate || endDate ? "50" : "100"} ${
                startDate || endDate ? "pointer-events-none" : ""
              }`}
            >
              <SliderOptions
                options={["Month", "Quarter", "Year"]}
                defaultValue={timeRange}
                onChange={(value) => {
                  setTimeRange(value);
                }}
              />
            </div>

            {/* Add a custom calender */}

            <div className="relative">
              <button
                disabled={loading}
                type="button"
                onClick={() => setShowCalendar((prev) => !prev)}
                className="px-3 py-2 border rounded-lg hover:bg-gray-100 flex items-center gap-2 text-xs"
              >
                <Calendar size={16} className="mph-primary" />

                {startDate && endDate ? (
                  <span>
                    {formatDisplayDate(startDate)} →{" "}
                    {formatDisplayDate(endDate)}
                  </span>
                ) : startDate ? (
                  <span>{formatDisplayDate(startDate)}</span>
                ) : (
                  <span className="text-gray-400">Select dates</span>
                )}
              </button>
              {showCalendar &&
                createPortal(
                  <div
                    ref={calendarRef}
                    className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-[9999]"
                    onClick={() => setShowCalendar(false)}
                  >
                    <div
                      className="bg-white shadow-2xl rounded-lg max-w-96 mx-4 absolute top-[11rem] right-[4rem]"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <DateRangePicker
                        selectedStart={startDate}
                        selectedEnd={endDate}
                        onChange={({ startDate: s, endDate: e }) => {
                          setShowCalendar(false);
                          setStartDate(s);
                          setEndDate(e);
                        }}
                      />
                    </div>
                  </div>,
                  document.body
                )}
            </div>
            {/* <div className="relative z-50 inline-block">
  <DateRangeCalendar 
    onDateRangeSelect={(startDate, endDate) => {
      console.log(startDate, endDate);
      // Optionally: setTimeRange logic here, e.g., compute custom period
    }}
  />
</div> */}
          </div>
        </div>
      </div>

     {/* Updated Container to Grid */}
<div className="px-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
  
    {/* Card 1: Candidates */}
  <div className="text-left bg-[#b2853d2e] p-3 rounded-2xl shadow-sm border border-gray-100 w-full flex flex-col gap-2 md:gap-1">
    <div className="flex items-center justify-between mb-2">
      <h3 className="font-semibold text-[12px]">Candidates (Profiler)</h3>
      <div className="rounded-full bg-gray-100 p-1">
        <UsersRound size={14} className="mph-primary" />
      </div>
    </div>
    {isTotalCandidatesApiLoading ? (
      <SmallCardLoader />
    ) : (
      totalCandidatesCard && (
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold mph-primary">
            {totalCandidatesCard?.active_candidates || 0}
          </h2>
        </div>
      )
    )}
  </div>


  {/* Card 2: Candidates */}
  <div className="text-left bg-white p-3 rounded-2xl shadow-sm border border-gray-100 w-full flex flex-col gap-2 md:gap-1">
    <div className="flex items-center justify-between mb-2">
      <h3 className="font-semibold text-[12px]">Candidates</h3>
      <div className="rounded-full bg-gray-100 p-1">
        <UsersRound size={14} className="mph-primary" />
      </div>
    </div>
    {isTotalCandidatesApiLoading ? (
      <SmallCardLoader />
    ) : (
      totalCandidatesCard && (
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold mph-primary">
            {totalCandidatesCard?.total_count || 0}
          </h2>
        </div>
      )
    )}
  </div>

  {/* Card 3: Recruiters */}
  <div className="text-left bg-white p-3 rounded-2xl shadow-sm border border-gray-100 w-full flex flex-col gap-4">
    <div className="flex items-center justify-between">
      <h3 className="font-semibold text-[12px] mt-1">Recruiters</h3>
      <div className="rounded-full bg-gray-100 p-1">
        <UserRoundCheck size={14} className="mph-primary" />
      </div>
    </div>
    {isActiveRecruitersApiLoading ? (
      <SmallCardLoader />
    ) : (
      activeRecruitersCard && (
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold mph-primary">
            {activeRecruitersCard?.total_count || 0}
          </h2>
        </div>
      )
    )}
  </div>

  {/* Card 4: Vacancies */}
  <div className="text-left bg-white p-3 rounded-2xl shadow-sm border border-gray-100 w-full flex flex-col gap-2 md:gap-1">
    <div className="flex items-center justify-between mb-2">
      <h3 className="font-semibold text-[12px] mt-1">Vacancies</h3>
      <div className="rounded-full bg-gray-100 p-1">
        <BriefcaseBusiness size={14} className="mph-primary" />
      </div>
    </div>
    {isCandidatesContactedApiLoading ? (
      <SmallCardLoader />
    ) : (
      totalVacanciesCard && (
        <div className="flex items-center gap-2">
          <h2 className="text-xl font-semibold mph-primary">
            {totalVacanciesCard?.total_vacancies || 0}
          </h2>
        </div>
      )
    )}
  </div>

  {/* Card 4: Power BI */}
  <div className="text-left bg-white p-3 rounded-2xl shadow-sm border border-gray-100 w-full flex flex-col gap-2 md:gap-1 lg:col-span-2">
    <div className="flex flex-col gap-4">
      <h3 className="font-semibold text-[12px]">Power BI</h3>
      <div className="flex flex-wrap gap-2">
        <a href="https://app.powerbi.com/groups/me/reports/6ba08e81-e772-4576-97fb-c2e4850fc517?ctid=95663b7e-9a8a-45f2-adfb-16f134b8ed2c&pbi_source=linkShare" target="_blank" rel="noreferrer" className="flex items-center bg-gradient text-white text-[10px] px-3 py-1.5 rounded-full w-fit cursor-pointer whitespace-nowrap">
          Client Analytics
        </a>
        <a href="https://app.powerbi.com/groups/me/reports/80a8be51-b22c-4025-b8bb-36a01726549e?ctid=95663b7e-9a8a-45f2-adfb-16f134b8ed2c&pbi_source=linkShare" target="_blank" rel="noreferrer" className="flex items-center bg-gradient text-white text-[10px] px-3 py-1.5 rounded-full w-fit cursor-pointer whitespace-nowrap">
          KPI Monthly
        </a>
        <a href="https://app.powerbi.com/groups/me/reports/423a722f-0a13-4561-a5a5-de95fffbe689?ctid=95663b7e-9a8a-45f2-adfb-16f134b8ed2c&pbi_source=linkShare" target="_blank" rel="noreferrer" className="flex items-center bg-gradient text-white text-[10px] px-3 py-1.5 rounded-full w-fit cursor-pointer whitespace-nowrap">
          KPI Weekly
        </a>
        <a href="https://app.powerbi.com/groups/me/reports/08c0cceb-33b8-42b0-907d-9b1d4e0ce5f7?ctid=95663b7e-9a8a-45f2-adfb-16f134b8ed2c&pbi_source=linkShare" target="_blank" rel="noreferrer" className="flex items-center bg-gradient text-white text-[10px] px-3 py-1.5 rounded-full w-fit cursor-pointer whitespace-nowrap">
          Operation Directors Dashboard
        </a>
        <a href="https://app.powerbi.com/groups/me/reports/c4f85738-1c3e-42a5-968d-5b921aab06bb?ctid=95663b7e-9a8a-45f2-adfb-16f134b8ed2c&pbi_source=linkShare" target="_blank" rel="noreferrer" className="flex items-center bg-gradient text-white text-[10px] px-3 py-1.5 rounded-full w-fit cursor-pointer whitespace-nowrap">
          Recruiters KPI
        </a>
      </div>
    </div>
  </div>

  {/* Card 5: Quick Actions */}
  {/* <div className="text-left bg-white p-3 rounded-2xl shadow-sm border border-gray-100 w-full flex flex-col gap-2 md:gap-1">
    <div className="flex flex-col gap-4">
      <h3 className="font-semibold text-[12px]">Quick Actions</h3>
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => onActionSelect("user")}
          className="flex gap-2 items-center bg-gradient text-white text-[10px] px-3 py-1.5 rounded-full w-fit cursor-pointer whitespace-nowrap"
        >
          <ChartLine size={12} />
          Candidate Insights
        </button>
        <button
          onClick={() => onActionSelect("entity")}
          className="flex gap-2 items-center bg-gradient text-white text-[10px] px-3 py-1.5 rounded-full w-fit cursor-pointer whitespace-nowrap"
        >
          <Database size={12} />
          Manage Entities
        </button>
      </div>
    </div>
  </div> */}
</div>

      {/*Dashboard Cards  */}
      {tab === "Candidate Demographics" && (
        <>
          <div className="flex-1 overflow-y-auto px-5 py-2 grid grid-cols-2 gap-4">
            <ChartCard
              isLoading={genderChartDataApiLoading}
              title="Gender Distribution"
              data={genderChartData}
              chartType="pie"
              exportToExcel={handleExportToExcel}
            />
            <ChartCard
              isLoading={cvOriginChartApiLoading}
              title="CV Origins"
              data={cvOriginChartData}
              chartType="pie"
              exportToExcel={handleExportToExcel}
            />

            <ChartCard
              isLoading={sectorWiseChartApiLoading}
              title="Sector Wise Placements"
              data={sectorWiseChartData}
              chartType="pie"
              exportToExcel={handleExportToExcel}
            />

            <ChartCard
              isLoading={hitRatioChartApiLoading}
              title="Hit Ratio by Sector"
              data={hitRatioChartData}
              chartType="pie"
              exportToExcel={handleExportToExcel}
            />

            
            <ChartCard
              isLoading={sectorWiseCandidatesApiLoading}
              title="Sector Wise Candidates"
              data={sectorwiseCandidatesData}
              chartType="pie"
              exportToExcel={handleExportToExcel}
            />

            <ChartCard
              isLoading={sectorWiseVacanciesApiLoading}
              title="Sector Wise Vacancies"
              data={sectorWiseVacanciesData}
              chartType="pie"
              exportToExcel={handleExportToExcel}
            />


                 <ChartCard
              isLoading={nationalityChartApiLoading}
              title="Top Nationalities"
              data={nationalityChartData}
              chartType="bar"
              size={"small"}
              exportToExcel={handleExportToExcel}
            />
            <ChartCard
              isLoading={jobLocationsChartApiLoading}
              title="Jobs by location"
              data={jobLocationsChartData}
              chartType="bar"
              size={"small"}
              exportToExcel={handleExportToExcel}
            />
          </div>

          <div
            id="demographics"
            className="flex-1 overflow-y-auto px-5 pt-1 pb-3 grid grid-cols-2 gap-4"
          >
       
            <ChartCard
              isLoading={ageChartApiLoading}
              title="Age Distribution"
              data={ageChartData}
              chartType="bar"
              size={"small"}
              exportToExcel={handleExportToExcel}
            />
            <ChartCard
              isLoading={locationChartApi}
              title="Top Locations"
              data={locationChartData}
              chartType="bar"
              size={"small"}
              exportToExcel={handleExportToExcel}
            />
          </div>
        </>
      )}

      {tab === "Recruiter Analytics" && (
        <>
          <div
            id="performance"
            className="flex-1 px-5 py-3 grid md:grid-cols-[1.5fr_1fr] grid-cols-1 gap-4 lg:grid-cols-[1.5fr_1fr]"
          >
            <div className="bg-white rounded-lg shadow p-4 w-full">
              <div className="flex justify-between items-center">
                <h2 className="text-xs font-bold text-gray-900 mb-3">
                  Recruiter Activity
                </h2>
                <button
                  className="text-emerald-800 hover:text-emerald-900 mb-3 hover:bg-gray-100 p-1 rounded-full"
                  onClick={() => recruiterActivityChart(null)}
                >
                  <Download size={12}></Download>
                </button>
              </div>
              {recruiterActivityApiLoading ? (
                <Loader />
              ) : recruiterActivityData && recruiterActivityData.length > 0 ? (
                <div
                  className="overflow-x-auto max-h-48"
                  onScroll={handleRecruiterActivityScroll}
                >
                  <table className="w-full table-fixed">
                    <thead>
                      <tr className="sticky top-0 z-10 border-b border-gray-200 bg-gray-100">
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600 w-1/6">
                          Name
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600 w-1/6">
                          Vacancies
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600 w-1/6">
                          Number of Candidates Views
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600 w-1/6">
                          Number of Candidates Contacted
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600 w-1/6">
                          Contacted by Email
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600 w-1/6">
                          Contacted by WhatsApp
                        </th>
                      </tr>
                    </thead>
                    <tbody className="max-h-32 overflow-y-auto">
                      {recruiterActivityData.map((recruiter, index) => (
                        <tr
                          key={index}
                          className="border-b border-gray-100 hover:bg-gray-50"
                        >
                          <td className="py-2 px-3 text-[10px]  font-bold">
                            {recruiter.recruiter_name}
                          </td>
                          <td className="py-2 px-3 text-[10px]  font-bold">
                            {recruiter.jobs_count}
                          </td>
                          <td className="py-2 px-3 text-[10px]  font-bold">
                            {recruiter.candidate_views}
                          </td>
                          <td className="py-2 px-3 text-[10px]  font-bold">
                            {recruiter.contacted_candidates}
                          </td>
                          <td className="py-2 px-3 text-[10px]  font-bold">
                            {recruiter.email_contacted_candidates}
                          </td>
                          <td className="py-2 px-3 text-[10px]  font-bold">
                            {recruiter.whatsapp_contacted_candidates}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {recruiterActivityLoadingMore && (
                    <div className="py-2 px-3 text-center text-[10px]">
                      Loading more...
                    </div>
                  )}
                </div>
              ) : (
                <EmptyState message="No recruiter activity records available" />
              )}
            </div>

            <ChartCard
              isLoading={candidateFunnelApiLoading}
              title="Candidate Funnel"
              data={candidateFunnelData}
              chartType="bar"
              exportToExcel={handleExportToExcel}
            />
          </div>

          <div className="flex-1 overflow-y-auto px-5 pb-3">
            <div className="bg-white rounded-lg shadow p-4">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-md">🏆</span>
                  <h2 className="text-xs font-bold text-gray-900">
                    Recruiter Leaderboard
                  </h2>
                </div>
                <div>
                  <button
                    className="text-emerald-800 hover:text-emerald-900 mb-3 hover:bg-gray-100 p-1 rounded-full"
                    onClick={() => fetchRecruiterLeaderboardChart(null)}
                  >
                    <Download size={12}></Download>
                  </button>
                </div>
              </div>
              {recruiterLeaderboardApiLoading ? (
                <Loader />
              ) : recruiterLeaderboardData &&
                recruiterLeaderboardData.length > 0 ? (
                <div
                  className="overflow-x-auto max-h-[11.5rem]"
                  onScroll={handleRecruiterLeaderboardScroll}
                >
                  <table className="w-full">
                    <thead>
                      <tr className="sticky top-0 z-10 border-b border-gray-200 bg-gray-100">
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600">
                          Rank
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600">
                          Name
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600">
                          Cvs Submitted To AM
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600">
                          Cvs Approved by AM
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600">
                          Cvs Submitted To Client
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600">
                          CVs Shortlisted
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600">
                          Selected for Mob
                        </th>
                        <th className="text-left py-2 px-3 text-[10px] font-semibold text-gray-600">
                          Placed
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {recruiterLeaderboardData.map((item, index) => (
                        <tr
                          key={index}
                          className="border-b border-gray-100 hover:bg-gray-50"
                        >
                          <td className="py-2 px-3 text-[10px] font-bold ">
                            {item.rank === 1 ? (
                              <span className="inline-flex items-center gap-1 font-bold">
                                🥇 #{item.rank}
                              </span>
                            ) : item.rank === 2 ? (
                              <span className="inline-flex items-center gap-1 font-bold">
                                🥈 #{item.rank}
                              </span>
                            ) : item.rank === 3 ? (
                              <span className="inline-flex items-center gap-1 font-bold">
                                🥉 #{item.rank}
                              </span>
                            ) : (
                              <span>#{item.rank}</span>
                            )}
                          </td>
                          <td className="py-2 px-3 text-[10px] text-gray-900  font-bold">
                            {item.recruiter_name}
                          </td>
                          <td className="py-2 px-3 text-[10px] text-gray-900 font-bold">
                            {item.submitted_to_am}
                          </td>
                          <td className="py-2 px-3 text-[10px] text-gray-900 font-bold">
                            {item.approved_by_am}
                          </td>
                          <td className="py-2 px-3 text-[10px] text-gray-900 font-bold  ">
                            {item.submitted_to_client}
                          </td>
                          <td className="py-2 px-3 text-[10px] text-gray-900 font-bold">
                            {item.shortlisted}
                          </td>
                          <td className="py-2 px-3 text-[10px] text-gray-900 font-bold  ">
                            {item.selected_for_mob}
                          </td>
                          <td className="py-2 px-3 text-[10px] text-gray-900 font-bold  ">
                            {item.placed}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {recruiterLeaderboardLoadingMore && (
                    <div className="py-2 px-3 text-center text-[10px]">
                      Loading more...
                    </div>
                  )}
                </div>
              ) : (
                <EmptyState message="No recruiter leaderboard records available" />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminDashboardContent;

const GrowthIndicator = ({ value, period }) => {
  const isPositive = value >= 0;
  const periodTextMap = {
    Year: "from last year",
    Quarter: "from last quarter",
    Day: "from yesterday",
  };

  const displayText = periodTextMap[period] || "from last month";

  return (
    <div className="text-[11px] text-gray-600 flex items-center gap-1">
      <span
        className={
          `font-semibold ` + (isPositive ? "text-green-600" : "text-red-600")
        }
      >
        {isPositive ? "↑" : "↓"} {Math.abs(value)}%
      </span>

      <span>{displayText}</span>
    </div>
  );
};

const SmallCardLoader = ({ size = "default" }) => {
  const sizeClasses = {
    small: {
      label: "h-3 w-8",
      value: "h-5 w-8",
    },
    default: {
      label: "h-5 w-12",
      // value: "h-6 w-10",
    },
    large: {
      label: "h-5 w-20",
      value: "h-7 w-12",
    },
  };

  const classes = sizeClasses[size] || sizeClasses.default;

  return (
    <div className="animate-pulse">
      <div className={`${classes.label} bg-gray-300 rounded mb-2`}></div>
      <div className={`${classes.value} bg-gray-200 rounded`}></div>
    </div>
  );
};

// const CardLoader = () => {
//   return (
//     <div className="w-full h-[250px] animate-pulse p-4 flex flex-col justify-center items-center space-y-4 bg-gray-100 rounded-xl">
//       <div className="h-4 w-32 bg-gray-300 rounded-full"></div>
//       <div className="w-full h-40 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 rounded-lg"></div>
//       <div className="flex w-full max-w-sm space-x-3">
//         <div className="flex-1 h-2 bg-gray-400 rounded"></div>
//         <div className="w-12 h-3 bg-gray-400 rounded-full"></div>
//         <div className="flex-1 h-3 bg-gray-400 rounded"></div>
//       </div>
//     </div>
//   );
// };
